import axios from "axios";
import { 
    baseURL, 
    GETPRODUCTCURRENCY, 
    CREATEPRODUCTCURRENCY, 
    UPDATEPRODUCTCURRENCY, 
    DELETEPRODUCTCURRENCY,
    SET_SELECTED_CURRENCY 
} from "./types";

// --- Helper Function jo colleague ne diya ---
// const makeApiRequest = (config, dispatch, type) => {
//   return new Promise((resolve, reject) => {
//     axios(config)
//       .then((response) => {
//         if (dispatch && type) {
//           dispatch({
//             type: type,
//             payload: response.data,
//           });
//         }
//         resolve(response.data);
//       })
//       .catch((error) => {
//         console.error(`API Error for ${config.url}:`, error);
//         reject(error);
//       });
//   });
// };
const makeApiRequest = (config, dispatch, type) => {
  return new Promise((resolve, reject) => {
    axios(config)
      .then((response) => {
        const res = response.data;

        // 1. Pehle generic dispatch (jo pehle se tha)
        if (dispatch && type) {
          dispatch({
            type: type,
            payload: res,
          });
        }

        // --- ADDED LOGIC START ---
        // Hum check kar rahe hain ki success 1 hai aur ye wahi specific API call hai
        if (res.success === 1 && type === "GETPRODUCTCURRENCY") {
          const savedCurrency = localStorage.getItem('selectedCurrency');
          
          if (savedCurrency && savedCurrency !== "undefined") {
            // Agar localStorage mein pehle se currency hai
            const parsed = JSON.parse(savedCurrency);
            dispatch({ type: "SET_SELECTED_CURRENCY", payload: parsed });
          } else {
            // Agar localStorage khali hai, toh Admin wali default set karo
            const defaultCurr = res.data.find(c => c.is_default === 1);
            if (defaultCurr) {
              // Yahan dispatch action creator ke saath ya direct object ke saath
              dispatch({ type: "SET_SELECTED_CURRENCY", payload: defaultCurr });
              // Recommended: LocalStorage mein save bhi kar lo taaki agli baar step 1 chale
              localStorage.setItem('selectedCurrency', JSON.stringify(defaultCurr));
            }
          }
        }
        // --- ADDED LOGIC END ---

        resolve(res);
      })
      .catch((error) => {
        console.error(`API Error for ${config.url}:`, error);
        reject(error);
      });
  });
};
// 1. GET ALL
// export const getproductCurrency = (data) => (dispatch) => {
//   const config = {
//     method: "post",
//     url: baseURL + "/api/appointmentCurrency/getall", // Aapka endpoint
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem("token")}`,
//       "Content-Type": "application/json",
//     },
//     data: data,
//   };
//   return makeApiRequest(config, dispatch, GETPRODUCTCURRENCY).then((res) => {
//       // Jab data aa jaye, default currency set karein
//       if(res.success === 1){
//           const defaultCurr = res.data.find(c => c.is_default === 1);
//           if(defaultCurr) dispatch(setSelectedCurrency(defaultCurr));
//       }
//       return res;
//   });
// };
// 1. GET ALL (Modified)
export const getproductCurrency = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/appointmentCurrency/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  // SIRF helper ko call karein. Helper ke andar ka logic handle karega:
  // "Ki agar localStorage khali hai tabhi Admin default uthao, warna purana rehne do"
  return makeApiRequest(config, dispatch, GETPRODUCTCURRENCY);
};
// 2. CREATE
export const createproductCurrency = (data) => (dispatch) => {
  const config = {
    method: "post",
    url: baseURL + "/api/appointmentCurrency/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, CREATEPRODUCTCURRENCY).then((res) => {
      dispatch(getproductCurrency({ hospitalID: data.hospitalID })); // Refresh list
      return res;
  });
};

// 3. UPDATE
export const updateproductCurrency = (data) => (dispatch) => {
  const config = {
    method: "patch",
    url: baseURL + "/api/appointmentCurrency/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, UPDATEPRODUCTCURRENCY).then((res) => {
      dispatch(getproductCurrency({ hospitalID: data.hospitalID })); // Refresh list
      return res;
  });
};

// 4. DELETE
export const deleteproductCurrency = (data) => (dispatch) => {
  const config = {
    method: "delete",
    url: baseURL + "/api/appointmentCurrency/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  return makeApiRequest(config, dispatch, DELETEPRODUCTCURRENCY).then((res) => {
    dispatch(getproductCurrency({ hospitalID: localStorage.getItem('hospitalCode') })); // Refresh list
    return res;
  });
};

// 5. SET SELECTED (For Header Dropdown)
export const setSelectedCurrency = (currencyObj) => (dispatch) => {
    localStorage .setItem('selectedCurrency', JSON.stringify(currencyObj));
    dispatch({ type: SET_SELECTED_CURRENCY, payload: currencyObj });
};